import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabase';

function Timeline() {
  var navigate = useNavigate();
  var [events, setEvents] = useState([]);
  var [loading, setLoading] = useState(true);
  var [showForm, setShowForm] = useState(false);
  var [form, setForm] = useState({
    event_date: new Date().toISOString().split('T')[0],
    title: '',
    content: '',
    author: 'zhizhi'
  });
  var [editing, setEditing] = useState(null);

  useEffect(function() {
    fetchEvents();
  }, []);

  var fetchEvents = async function() {
    var result = await supabase
      .from('timeline_events')
      .select('*')
      .order('event_date', { ascending: true });
    setEvents(result.data || []);
    setLoading(false);
  };

  var addEvent = async function() {
    if (!form.title.trim()) return;
    await supabase.from('timeline_events').insert([{
      event_date: form.event_date,
      title: form.title,
      content: form.content || null,
      author: form.author
    }]);
    setForm({
      event_date: new Date().toISOString().split('T')[0],
      title: '',
      content: '',
      author: 'zhizhi'
    });
    setShowForm(false);
    fetchEvents();
  };

  var updateEvent = async function() {
    if (!editing || !form.title.trim()) return;
    await supabase.from('timeline_events').update({
      event_date: form.event_date,
      title: form.title,
      content: form.content || null,
      author: form.author
    }).eq('id', editing);
    setEditing(null);
    setForm({
      event_date: new Date().toISOString().split('T')[0],
      title: '',
      content: '',
      author: 'zhizhi'
    });
    setShowForm(false);
    fetchEvents();
  };

  var deleteEvent = async function(id) {
    await supabase.from('timeline_events').delete().eq('id', id);
    fetchEvents();
  };

  var startEdit = function(ev) {
    setForm({
      event_date: ev.event_date,
      title: ev.title,
      content: ev.content || '',
      author: ev.author
    });
    setEditing(ev.id);
    setShowForm(true);
  };

  var formatDate = function(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    return d.getFullYear() + '.' + (d.getMonth() + 1).toString().padStart(2, '0') + '.' + d.getDate().toString().padStart(2, '0');
  };
  return (
    <div className="timeline-page">
      <div className="timeline-header">
        <button className="timeline-back" onClick={function() { navigate('/'); }}>
          ‹ 返回
        </button>
        <div className="timeline-title">时间轴</div>
        <button className="timeline-add-btn" onClick={function() {
          if (showForm && editing) {
            setEditing(null);
            setForm({ event_date: new Date().toISOString().split('T')[0], title: '', content: '', author: 'zhizhi' });
          }
          setShowForm(!showForm);
        }}>
          {showForm ? '取消' : '+ 添加'}
        </button>
      </div>

      {showForm && (
        <div className="timeline-form">
          <input className="timeline-input" type="date" value={form.event_date}
            onChange={function(e) { setForm(Object.assign({}, form, { event_date: e.target.value })); }} />
          <input className="timeline-input" placeholder="事件标题" value={form.title}
            onChange={function(e) { setForm(Object.assign({}, form, { title: e.target.value })); }} />
          <textarea className="timeline-textarea" placeholder="心得 / 详细内容（选填）" value={form.content}
            onChange={function(e) { setForm(Object.assign({}, form, { content: e.target.value })); }} rows={4} />
          <div className="timeline-form-row">
            <select className="timeline-select" value={form.author}
              onChange={function(e) { setForm(Object.assign({}, form, { author: e.target.value })); }}>
              <option value="zhizhi">知枝</option>
              <option value="aiden">林晏</option>
            </select>
            <button className="timeline-submit" onClick={editing ? updateEvent : addEvent}>
              {editing ? '更新' : '保存'}
            </button>
          </div>
        </div>
      )}

      <div className="timeline-body">
        {loading ? (
          <div className="timeline-empty">加载中...</div>
        ) : events.length === 0 ? (
          <div className="timeline-empty">还没有事件，添加我们的第一个故事吧</div>
        ) : (
          <div className="timeline-line-wrap">
            <div className="timeline-line"></div>
            {events.map(function(ev) {
              return (
                <div key={ev.id} className="timeline-event">
                  <div className="timeline-dot-wrap">
                    <div className={'timeline-dot ' + ev.author}></div>
                  </div>
                  <div className="timeline-event-card">
                    <div className="timeline-event-date">{formatDate(ev.event_date)}</div>
                    <div className="timeline-event-title">{ev.title}</div>
                    {ev.content && <div className="timeline-event-content">{ev.content}</div>}
                    <div className="timeline-event-footer">
                      <span className={'timeline-event-author ' + ev.author}>
                        {ev.author === 'aiden' ? '林晏' : '知枝'}
                      </span>
                      <span className="timeline-event-actions">
                        <button className="timeline-edit-btn" onClick={function(e) { e.stopPropagation(); startEdit(ev); }}>编辑</button>
                        <button className="timeline-del-btn" onClick={function(e) { e.stopPropagation(); deleteEvent(ev.id); }}>删除</button>
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Timeline;
